// extracted by mini-css-extract-plugin
module.exports = {"collection":"TagCollection_collection__1k3Wz","expanded":"TagCollection_expanded__393Wb","collectionTag":"TagCollection_collectionTag__1Nms5"};